import { authClient } from "@/lib/auth-client";
import { Navigate, Outlet } from "react-router";
import { Loader } from "lucide-react";

import licitigo_logo from "../../assets/licitigo_logo.svg";

export default function AdminGuard() {
  const { data: session, isPending } = authClient.useSession();

  if (isPending) {
    return (
      <div className="flex h-screen w-full flex-col items-center justify-center gap-6">
        <img src={licitigo_logo} alt="Licitigo" className="h-14 w-auto" />
        <Loader className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/auth/login" replace />;
  }

  const role = (session.user as { role?: string | null }).role;
  if (role !== "admin") {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
